import { extendTheme } from '@chakra-ui/react';

// Heading
const Heading = {
  baseStyle: {
    fontWeight: 700,
    color: '#3c474e',
    marginBottom: '6',
  },
  // Styles for the size variations
  sizes: {
    '4xl': {
      fontSize: ['4xl', null, '7xl'],
    },
    '3xl': {
      fontSize: ['4xl', null, '6xl'],
    },
  },
  // Styles for the visual style variations
  variants: {
    sec: {
      color: '#505b62',
    },
  },
  // The default `size` or `variant` values
  defaultProps: {},
};

const theme = extendTheme({
  initialColorMode: 'light',
  useSystemColorMode: false,
  textStyles: {
    lineHeight: '1.5',
  },
  components: {
    Input: {},
    Textarea: {},
    Link: {
      baseStyle: {
        textDecoration: 'underline',
      },
    },
    Button: {
      baseStyle: {
        _focus: { boxShadow: 'none' },
        _hover: {
          textDecoration: 'underline',
        },
        borderRadius: '20px',
        fontWeight: 600,
        minWidth: '10rem',
        paddingLeft: '.5rem',
        paddingRight: '.5rem',
      },
      variants: {
        btnCTA: {
          backgroundColor: 'brand.one',
          // bgGradient: 'linear(to-br, , brand.five , brand.six 40% ,brand.two )',
          textTransform: 'uppercase',
          color: 'white',
        },
        btnOne: {
          color: 'brand.dark',
          backgroundColor: 'brand.six',
        },
        btnTwo: {
          // backgroundColor: 'transparent',
          color: 'brand.dark',
          border: '2px',
          borderColor: 'brand.three',
        },
      },
    },
    Text: {
      baseStyle: {
        fontWeight: 400,
      },
    },
    Heading,
  },
  fonts: {
    heading: "'Manrope', sans-serif",
    body: "'Inter', sans-serif;",
  },
  styles: {
    global: {
      body: {
        minHeight: '100vh',
      },
      a: {
        color: 'teal.500',
      },
    },
  },
  colors: {
    black: '#0a0a0a',
    white: '#FFFFFF', // '#E8ECFA', //'#F5F8FC',
    brand: {
      one: '#ff8000',
      two: '#ec9272',
      three: '#f1b099', // '#1C4766', // blue dark
      four: '#ffc893', // blue light
      five: '#eef6f9', // dark blue
      six: '#5080c0', // dark blue
      seven: '#0553ad', // navy
      eight: '#2f578b',
      nine: '#092c57',
    },
  },
});

export default theme;
